//文字コードはutf-8

// スムーススクロール
export function initSmoothScroll() {
  // イージング関数（easeInOutQuad）
  const easeInOutQuad = (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  // スクロールアニメーションの設定
  const scrollToTarget = (target, offset = 0) => {
    if (!target) return;
    
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = targetPosition - offset;
    const startPosition = window.pageYOffset;
    const distance = offsetPosition - startPosition;
    const duration = 800; // スクロール時間（ミリ秒）
    let startTime = null;

    // アニメーション関数
    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutQuad(progress);
      
      window.scrollTo(0, startPosition + distance * ease);
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  };

  // ヘッダーの高さを取得（固定ヘッダーの場合のオフセット用）
  const getHeaderOffset = () => {
    const header = document.querySelector('.header');
    return header ? header.offsetHeight : 0;
  };

  // ページ内リンクのクリックイベント
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      
      // "#"のみの場合はページトップへスムーススクロール
      if (href === '#') {
        const startPosition = window.pageYOffset;
        const distance = -startPosition;
        const duration = 800;
        let startTime = null;

        const animation = (currentTime) => {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const ease = easeInOutQuad(progress);
          
          window.scrollTo(0, startPosition + distance * ease);
          
          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        };

        requestAnimationFrame(animation);
        return;
      }
      
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const offset = getHeaderOffset();
        scrollToTarget(targetElement, offset);
        
        // URLのハッシュを更新（履歴に追加）
        history.pushState(null, '', href);
      }
    });
  });

  // ページ読み込み時に#付きURLからアクセスした場合の処理
  const handleHashOnLoad = () => {
    const hash = window.location.hash;
    
    if (hash) {
      // CSSのscroll-padding-topにより、ブラウザのデフォルトジャンプで正しい位置に移動する
      // スクロール位置の復元を無効化して、アンカー位置へのジャンプを優先
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
    }
  };

  // ページ読み込み完了後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }
  
  // 画像などの読み込み完了後、位置がずれている場合は即座に修正
  window.addEventListener('load', () => {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // 画像読み込みにより位置がずれている可能性があるため、
        // ブラウザに再度アンカー位置へのスクロールを促す
        // scroll-padding-topが適用されるため、正しい位置に移動する
        targetElement.scrollIntoView();
      }
    }
  });

  // ブラウザの戻る・進むボタンでハッシュが変わった時の処理
  window.addEventListener('popstate', () => {
    const hash = window.location.hash;
    
    if (hash) {
      const targetId = hash.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const offset = getHeaderOffset();
        scrollToTarget(targetElement, offset);
      }
    }
  });
}

